"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = require("react");
var _papaparse = _interopRequireDefault(require("papaparse/papaparse.js"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["accept", "encoding", "onError", "parserOptions", "onFileLoaded", "onChange", "strict"]; // @ts-ignore
var CSVReader = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _props$accept = props.accept,
    accept = _props$accept === void 0 ? '.csv, text/csv' : _props$accept,
    _props$encoding = props.encoding,
    encoding = _props$encoding === void 0 ? 'UTF-8' : _props$encoding,
    _props$onError = props.onError,
    onError = _props$onError === void 0 ? function () {} : _props$onError,
    _props$parserOptions = props.parserOptions,
    parserOptions = _props$parserOptions === void 0 ? {} : _props$parserOptions,
    onFileLoaded = props.onFileLoaded,
    onChange = props.onChange,
    _props$strict = props.strict,
    strict = _props$strict === void 0 ? false : _props$strict,
    reset = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var handleChangeFile = function handleChangeFile(event) {
    onChange && onChange(event);
    var reader = new FileReader();
    var files = event.target.files;
    if (files.length > 0) {
      var fileInfo = {
        name: files[0].name,
        size: files[0].size,
        type: files[0].type,
        modifiedAt: files[0].lastModified
      };
      if (strict && accept.indexOf(fileInfo.type) <= 0) {
        onError(new Error("[strict mode] Accept type not respected: got '".concat(fileInfo.type, "' but not in '").concat(accept, "'")));
        return;
      }
      reader.onload = function (_event) {
        var _csvData$data;
        var csvData = _papaparse["default"].parse(reader.result, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, parserOptions), {}, {
          error: onError,
          encoding: encoding
        }));
        onFileLoaded && onFileLoaded((_csvData$data = csvData === null || csvData === void 0 ? void 0 : csvData.data) !== null && _csvData$data !== void 0 ? _csvData$data : [], fileInfo, files[0], reader.result);
      };
      reader.readAsText(files[0], encoding);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("input", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    type: "file",
    name: "w-csv-reader-input"
  }, reset), {}, {
    onChange: handleChangeFile,
    accept: accept,
    ref: ref
  }));
});
var _default = exports["default"] = CSVReader;
module.exports = exports.default;